import { GenericDatabase } from './GenericDatabase'

const DB_NAME = 'Sites'
const DB_VERSION = 1
const STORE_NAME = 'Obras'

const dbInstance = new GenericDatabase(DB_NAME, DB_VERSION, [
    { name: STORE_NAME, keyPath: 'id' }
])

const initDbObras = () => {
    return dbInstance.init()
}

const agregar = (data, database) => {
    return dbInstance.add(STORE_NAME, data, database)
}

const obtener = (clave, database) => {
    // Original seemed to do nothing on success. Returning the actual object.
    return dbInstance.get(STORE_NAME, clave, database)
}

const actualizar = (data, database) => {
    return dbInstance.put(STORE_NAME, data, database)
}

const eliminar = (clave, database) => {
    // Original called consultar() on success.
    return dbInstance.delete(STORE_NAME, clave, database)
}

const consultar = (database) => {
    return dbInstance.getAll(STORE_NAME, database)
}

export default {
    initDbObras,
    agregar,
    obtener,
    actualizar,
    eliminar,
    consultar
}
